import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {Column, Row} from "simple-flexbox";
import {css, StyleSheet} from "aphrodite";
import DetailTitleComponent from "../../components/detail/DetailTitleComponent";
import DetailContentLihatBerkas from "../../components/detail/DetailContentLihatBerkas";
import {
    getRegisteredList,
    getRegisteredListError,
    getRegisteredListPending
} from "../../reducers/registrasi_member/regist_member_reducer";
import {registeredList} from "../../actions/registrasi_member/regist_member_action";
import ModalDetailDokumen from "../admin-p2kb/Modal_document";
import ModalDetailDokumenPDF from "../../components/global-components/Modal_document_pdf";

class DetailBerkas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItem: "profil",
            data: null,
            modalDetailDokumenShow: false,
            modalDetailPdfShow: false,
            imgUrl: "",
            dataUrl: "",
            modal_title: "",
            folder: "member_supporting_files",
        };
        this.tableRef = React.createRef();
        this.handleOpenFoto = this.handleOpenFoto.bind(this);
        this.handleOpenKTP = this.handleOpenKTP.bind(this);
    }

    componentDidMount() {
        const { match: { params: { id } } } = this.props;
        this.props.registeredList({
            id: id
        })
    }

    handleOpenFoto(imgUrl, modal_title) {
        this.setState({ imgUrl: imgUrl });
        this.setState({ modal_title: modal_title });
        this.setState({ modalDetailDokumenShow: true });
    }

    handleOpenKTP(imgUrl, modal_title) {
        this.setState({ imgUrl: imgUrl });
        this.setState({ modal_title: modal_title });
        this.setState({ modalDetailDokumenShow: true });
    }

    handleOpenBranchreport(url, modal_title) {
        if (url.includes(".pdf")) {
            this.setState({
                modalDetailPdfShow: true,
                dataUrl: url,
                modalTitle: modal_title
            });
        } else {
            this.setState({
                modalDetailDokumenShow: true,
                imgUrl: url,
                modalTitle: modal_title
            });
        }

    }

    render() {
        const {registeredList_data} = this.props;
        const data = registeredList_data?.data[0];
        const is_branch_reporting_letter = !data?.branch_reporting_letter_number && !data?.branch_reporting_letter_file
        return (
            <Row className={css(styles.rightDetailContainer)}>
                <ModalDetailDokumen
                    show={this.state.modalDetailDokumenShow}
                    onHide={() => {
                        this.setState({ modalDetailDokumenShow: false })
                        setTimeout(function() {
                            document.body.removeAttribute('style')
                        }, 500);
                    }}
                    imgUrl={this.state.imgUrl}
                    modal_title={this.state.modal_title}
                    folder={this.state.folder}
                />
                <ModalDetailDokumenPDF
                    show={this.state.modalDetailPdfShow}
                    onHide={() => {
                        this.setState({ modalDetailPdfShow: false })
                        setTimeout(function() {
                            document.body.removeAttribute('style')
                        }, 500);
                    }}
                    imgUrl={this.state.dataUrl}
                    modal_title={this.state.modal_title}
                    folder={this.state.folder}
                />
                <Column className={css(styles.rightDetailColumn)}>
                    <DetailTitleComponent title="Berkas Pendukung"/>
                    {(!data?.photo && !data?.scan_ktp_image && is_branch_reporting_letter) ? <div className={css(styles.span)}>Tidak ada data Berkas Pendukung</div> :
                        <div>
                            <div className={css(styles.span)}>
                                Foto
                            </div>
                            {(data?.photo ? <DetailContentLihatBerkas onClick={() =>
                                this.handleOpenFoto(
                                    data?.photo,
                                    "Foto"
                                )}/> : <div className={css(styles.span)}>Tidak ada data <hr/></div> )}
                            <div className={css(styles.span)}>
                                KTP
                            </div>
                            {(data?.scan_ktp_image ? <DetailContentLihatBerkas onClick={() =>
                                this.handleOpenKTP(
                                    data?.scan_ktp_image,
                                    "KTP"
                                )
                            }/>: <div className={css(styles.span)}>Tidak ada data <hr/></div>)}
                            <div className={css(styles.span)}>
                                No Surat Tanda Lapor Cabang
                            </div>
                            <div className={css(styles.span)}>
                                {data?.branch_reporting_letter_number || "-"} <hr/>
                            </div>
                            <div className={css(styles.span)}>
                                Surat Tanda Lapor Cabang
                            </div>
                            {(data?.branch_reporting_letter_file ? <DetailContentLihatBerkas onClick={() =>
                                this.handleOpenBranchreport(
                                    data?.branch_reporting_letter_file,
                                    "Surat Tanda Lapor Cabang"
                                )
                            }/> : <div className={css(styles.span)}>Tidak ada data</div> )}
                        </div>
                    }
                    </Column>
                </Row>
        );
    }
}

const styles = StyleSheet.create({
    span: {
        marginBottom: 5,
        marginTop: 10,
        color: "#495057"
    },
    leftDetailContainer: {
        width: "30%",
        background: "#F8F9FB 0% 0% no-repeat padding-box",
        borderRight: "2px solid rgba(192,192,192, 0.5)",
        opacity: 1,
        padding: 40,
        alignItems: "center",
        justifyContent: "center",
        display: "block"
    },
    rightDetailContainer: {
        padding: 0,
        width: "100%"
    },
    rightDetailColumn: {
        width: "100%"
    },
    leftDetailColumn: {
        justifyContent: "center",
        alignItems: "center"
    },
    changeStatusButton: {
        padding: 0,
        fontSize: 14
    },
    clickableIcon: {
        ":hover": {
            cursor: "pointer"
        }
    }
});

function mapStateToProps({ registeredList }) {
    return {
        registeredList_pending: getRegisteredListPending(registeredList),
        registeredList_data: getRegisteredList(registeredList),
        registeredList_error: getRegisteredListError(registeredList),
    };
}

export default connect(mapStateToProps, { registeredList })(
    withRouter(DetailBerkas)
);